var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                  },
                  [
                    _c(
                      "c-table",
                      {
                        ref: "inTable",
                        attrs: {
                          title: "내부참석자 목록",
                          columns: _vm.inGrid.columns,
                          gridHeight: "250px",
                          data: _vm.data.attendeeInModels,
                          filtering: false,
                          columnSetting: false,
                          usePaging: false,
                          noDataLabel: "내부참석자를 추가하세요.",
                          hideBottom: true,
                          editable: _vm.editable,
                          checkClickFlag: false,
                          isExcelDown: false,
                          rowKey: "proceedingsAttendeeId",
                          selection: "multiple",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "table-button" },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              [
                                _vm.editable
                                  ? _c("c-btn", {
                                      attrs: {
                                        showLoading: false,
                                        label: "추가",
                                        icon: "add",
                                      },
                                      on: { btnClicked: _vm.addInAttendee },
                                    })
                                  : _vm._e(),
                                _vm.editable &&
                                _vm.data.attendeeInModels.length > 0
                                  ? _c("c-btn", {
                                      attrs: {
                                        showLoading: false,
                                        label: "삭제",
                                        icon: "remove",
                                      },
                                      on: { btnClicked: _vm.removeInAttendee },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                  },
                  [
                    _c(
                      "c-table",
                      {
                        ref: "outTable",
                        attrs: {
                          title: "외부참석자 목록",
                          columns: _vm.outGrid.columns,
                          gridHeight: "250px",
                          data: _vm.data.attendeeOutModels,
                          filtering: false,
                          columnSetting: false,
                          usePaging: false,
                          noDataLabel: "외부참석자를 추가하세요.",
                          hideBottom: true,
                          checkClickFlag: false,
                          isExcelDown: false,
                          editable: _vm.editable,
                          rowKey: "proceedingsAttendeeId",
                          selection: "multiple",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "table-button" },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              [
                                _vm.editable
                                  ? _c("c-btn", {
                                      attrs: {
                                        showLoading: false,
                                        label: "추가",
                                        icon: "add",
                                      },
                                      on: { btnClicked: _vm.addOutAttendee },
                                    })
                                  : _vm._e(),
                                _vm.editable &&
                                _vm.data.attendeeOutModels.length > 0
                                  ? _c("c-btn", {
                                      attrs: {
                                        showLoading: false,
                                        label: "삭제",
                                        icon: "remove",
                                      },
                                      on: { btnClicked: _vm.removeOutAttendee },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "관련 회의록" },
                  },
                  [
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-12 col-md-12 col-lg-12",
                          staticStyle: { height: "460px" },
                        },
                        [
                          _c("c-upload", {
                            attrs: {
                              attachInfo: _vm.attachInfo,
                              editable: _vm.editable,
                              label: "관련 회의록",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }